"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupLevel = void 0;
/**
 * 分组方式(日期，文本) 日期：relative | day | week | month | year。文本： exact | alphabet_prefix
 */
var GroupLevel;
(function (GroupLevel) {
    GroupLevel["RELATIVE"] = "relative";
    GroupLevel["DAY"] = "day";
    GroupLevel["WEEK"] = "week";
    GroupLevel["MONTH"] = "month";
    GroupLevel["YEAR"] = "year";
    GroupLevel["EXACT"] = "exact";
    GroupLevel["ALPHABET_PREFIX"] = "alphabet_prefix";
})(GroupLevel = exports.GroupLevel || (exports.GroupLevel = {}));
